<template>
  <div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12"  md="6" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>WiFi Controller</h1>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="3" class="text-center">
            <h4>{{messageStep}}</h4>
          </v-col>
          <v-col cols="12"  md="3">
            <div style="display: flex; justify-content: center; align-items: center">
              <v-btn text @click="connect" v-if="!isVisible">
                <v-icon x-large color="cyan darken-2">autorenew</v-icon>
              </v-btn>
              <div v-if="isVisible" class="load-3">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-progress-linear
          :indeterminate="query"
          :active="show"
          color="blue"
        ></v-progress-linear>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="2">
            <v-row align="center">
              <v-col cols="12" md="6" class="text-center">
                <v-tooltip top color="secondary" v-if="editPermission">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newNetwork" v-on="on">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </template>
                  <span>Create a new</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="renderedNetwork"
        :search="search"
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td style="text-align: center"
                v-for="(header, index) in headers"
                v-if="header.text !== 'Actions'"
                :key="index"
            >{{props.item[header.value]}}</td>
            <td v-else-if="admin || editPermission" style="text-align: center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon  :color="isConnected ? 'green' : 'orange'"  v-on="on">
                    wifi
                  </v-icon>
                </template>
                <span>{{isConnected ? 'connected' : 'conneting'}}</span>
              </v-tooltip>
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon  color="blue" @click="rowSelected(props.item) " v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon color="red" @click="toggleDeleteDialog(props.item)" v-on="on" class="pl-1">
                    delete
                  </v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <WiFiClientController
      :isConnected="isConnected"
    ></WiFiClientController>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title>
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text>
          You are about to delete this network. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="toBeDeleted=null; deleteDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteNetwork">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="editDialog" v-if="displayedItem" width="800px">
      <v-card>
        <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h2>{{editedIndex > -1 ? 'Edit network' : 'New network'}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="editDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row justify="space-around">
            <v-list two-line>
              <v-row justify="center" align="center">
                <v-col cols="12" sm="12" md="6" class="py-0" v-for="(key, index) in Object.keys(this.displayedItem).filter(function(e) { return e !== 'depot_name' && e !== 'id' })" :key="index">
                  <v-list-item>
                    <v-list-item-action>
                      <div>
                        <v-icon>{{icons[key]}}</v-icon>
                      </div>
                    </v-list-item-action>
                    <v-list-item-content class="pt-0">
                      <div >
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <div v-if="key === 'depot_id'">
                            <v-select
                              label="Depot"
                              :items="depotsRendered"
                              item-value="id"
                              item-text="name"
                              v-model="editedItem[key]"></v-select>
                          </div>
                          <div v-else>
                            <v-text-field v-model="editedItem[key]"
                                          :label="capitalizeFirstLetter(key)"
                                          :disabled="readOnly.includes(key)"
                            ></v-text-field>
                          </div>
                        </v-form>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>
          </v-row>
          <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
            <v-col md="2" cols="12" class="text-center">
              <v-btn
                text
                @click="editDialog=false;"
                color="blue-grey lighten-2"
              >Cancel
              </v-btn>
            </v-col>
            <v-col md="2" cols="12" class="text-center">
              <v-btn
                text
                @click="saveChanges"
                color="blue darken-1"
              >Save
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import WiFiClientController from '../../util/WiFiClientController'

export default {
  name: "Network",
  components:{WiFiClientController},
    data() {
      return {
        query:false,
        interval:0,
        show:true,

        valid: false,
        fab: false,
        info:'',
        isVisible:false,
        reload:false,
        requiredRule: [
          v => !!v || 'This field is required.'
        ],
        icons: {
          id: 'card_travel',
          depot_id: 'location_city',
          ip_address:'IP',
          port: 'smartphone',
          version: 'phonelink_setup',
        },
        readOnly: [
          "id",
          "depot_name"
        ],
        search: null,
        toBeDeleted: null,
        deleteDialog: false,
        editedIndex: -1,
        editedItem: {
          id: 0,
          depot_id: null,
          ip_address: null,
          port: null,
          version: null,
        },
        defaultNetwork: {
          id: 0,
          depot_id: null,
          ip_address: null,
          port: null,
          version: null,
        },
        editDialog: false,
        displayedItem: null,
        headers:[
          {text: 'ID', value: 'id', align: 'center', sortable: true},
          {text: 'Depot', value: 'depot_name', align: 'center', sortable: false},
          {text: 'IP', value: 'ip_address', align: 'center', sortable: false},
          {text: 'Port', value: 'port', align: 'center', sortable: false},
          {text: 'Version', value: 'version', align: 'center', sortable: false},
          {text: 'Actions', value: 'actions', align: 'center', sortable: false}
        ],
        isConnected:true,
        messageStep: '',
        requestLoop: null,
        jobId:null,
        info1:'',
    }
  },
  methods: {
    newNetwork() {
      this.editedIndex = -1;
      this.displayedItem = Object.assign({}, this.defaultNetwork);
      this.editedItem = Object.assign({}, this.defaultNetwork);
      this.fab = false;
      this.editDialog = true;
    },
    capitalizeFirstLetter(string) {
      string = string.replace(/_/g, ' ');
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    rowSelected(item) {
       this.displayedItem = Object.assign({}, item);
       this.editedItem = Object.assign({}, this.displayedItem);
       this.editedItem.depot_id =  this.editedItem.depot_id * 1;
       this.editedIndex = this.network.indexOf(item);
      this.editDialog = true;
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    queryIndeteminate(){
      this.query = true;
      this.show = true;
      this.interval = setTimeout(() => {
          this.query = false;
          this.show = false;
        }, 3000)
    },
    connect(){
      setTimeout(() => this.isVisible = false, 1000);
      this.isVisible = true;
      this.queryIndeteminate();

      axios.get(process.env.API_URL + '/network')
        .then((response) => {
            this.info = response.data;
            this.jobId = response.data.id;
            return response.data;
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
        })
    },
    checkConnect(){
      if( this.jobId !== null){
        axios.get(process.env.API_URL + '/jobs/' + this.jobId)
          .then((response) => {
            this.info1 = response.data;
            if (response.data.status === 1) {
              this.isConnected = false;
              this.messageStep = 'Job has been queued';
            }
            if (response.data.status === 2) {
              this.isConnected = false;
              this.messageStep = 'Job is being processed';
              if (response.data.message !== null) {
                this.messageStep = response.data.message;
              }
            }
            if (response.data.status === 3) {
              this.messageStep = 'Job complete';
              this.isConnected = true;
              clearInterval(this.requestLoop);
              this.$emit('Macs-updated')
            }
            if (response.data.status === 4) {
              this.isConnected = false;
              this.messageStep = 'An error has occurred'
              clearInterval(this.requestLoop);
            }
            return response.data;
          })
          .catch((response) => {
             clearInterval(this.requestLoop);
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      }
    },
    checkLoop() {
      this.requestLoop = setInterval(this.checkConnect, 1500);
    },
    toggleDeleteDialog(item) {
      this.toBeDeleted = item;
      this.deleteDialog = true;
    },
    deleteNetwork() {
      let index = this.network.indexOf(this.toBeDeleted);
      axios.delete(process.env.API_URL + '/network/' + this.toBeDeleted.id)
        .then((response) => {
          this.updateDataTable();
          this.deleteDialog = false;
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
        })
    },
    saveChanges() {
      let body = this.editedItem;
      if (this.editedIndex > -1) {
        axios.put(process.env.API_URL + '/network/' + body.id, body)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'Changes saved.');
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      } else {
        axios.post(process.env.API_URL + '/network', body)
          .then((response) => {
            this.updateDataTable();
            this.$store.commit('displaySnackbar', 'network created.');x
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
      }
      this.editDialog = false;
    }
  },
  computed: {
    admin() {
      return this.$store.getters['auth/isAdmin'];
    },
    editPermission() {
      return this.$store.getters['auth/isAdmin'];
    },
    renderedNetwork() {
      if (this.network === null){
        return [];
      } else return this.network;
    },
    depotsRendered: function () {
      if (this.depots === null || this.depots === undefined) return [];
      return this.depots;
    },
  },
  mounted() {
    this.queryIndeteminate();
    this.checkLoop();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.requestLoop);
  },
  asyncComputed: {
    async network() {
      if (this.reload || !this.reload) {
        return await axios.get(process.env.API_URL + '/network')
          .then((response) => {
            return response.data;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            return [];
          })
      }
    },
    async depots() {
      return await axios.get(process.env.API_URL + '/depots')
        .then((response) => {
          return response.data;
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          return [];
        });
    }
  }
}
</script>

<style scoped>
>>>.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none!important;
}

.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
0 {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}

.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Network.vue